import DISPLAY_SETTINGS from "./display_settings_config";

let translation_and_params_config = {
    query_params: {
        env: 'SEVDEIR'
    },
    filter_params: {
        organization: {},
        information_resource: {},
        subsystem: {},
        interface: {},
        service: {},
        interaction: {},
        server: {},
    },
    configuration: DISPLAY_SETTINGS,

    responsible_person_table_banner: "Зверніть увагу!!! Дані які були подані раніше щодо відповідальних осіб вашої організації у попередніх повідомленнях будуть деактивовані адміністратором системи Трембіта. В даному розділі повинні бути вказані дані відповідальної особи, яка відповідає за внесення та підтримку в актуальному стані інформації про організацію, електронні інформаційні ресурси, програмні інтерфейси та адміністрування компонентів системи Трембіта. Можна визначити декілька відповідальних осіб.",
    organization_register_responsible_person_table_banner: "Зверніть увагу!!! В даному розділі повинні бути вказані дані відповідальної особи, яка відповідає за внесення та підтримку в актуальному стані інформації про організацію, електронні інформаційні ресурси, програмні інтерфейси та адміністрування компонентів системи Трембіта. Можна визначити декілька відповідальних осіб.",

    translation: {
        ua: {
            MAIN_PAGE_ORGANIZATIONS_DESCRIPTION: 'Тут ви можете дізнатися все про органи державної влади, органи місцевого самоврядування та суб’єкти господарювання, що приєдналися до системи',
            MAIN_PAGE_INFORMATION_RESOURCES_DESCRIPTION: 'Тут ви можете дізнатися все про електронні інформаційні ресурси (реєстри, каталоги, класифікатори тощо), що підключені до системи',
            MAIN_PAGE_SUBSYSTEMS_DESCRIPTION: 'Тут ви можете дізнатися все про ідентифікатори опублікованих у системі е-ресурсів',
            MAIN_PAGE_INTERFACES_DESCRIPTION: 'Тут ви можете дізнатися все про набори даних, що можна отримати з (передати до) е-ресурсів',
            MAIN_PAGE_SERVICES_DESCRIPTION: 'Тут ви можете дізнатися все про ідентифікатори методів вебсервісів, що опубліковані в системі',
            MAIN_PAGE_EXCHANGES_DESCRIPTION: 'Тут ви можете дізнатися все про налагоджені обміни даними між е-ресурсами',
            MAIN_PAGE_SERVERS_DESCRIPTION: 'Тут ви можете побачити перелік шлюзів безпечного обміну',

            FOOTER_LEFT_TEXT: 'Якщо ви маєте зауваження або пропозиції, будь ласка, напишіть нам: trembita@diia.gov.ua',
            FOOTER_RIGHT_TEXT: 'Каталог системи «Трембіта» створено Міністерством цифрової трансформації України та державним підприємством «Дія» за підтримки проєкту міжнародної технічної допомоги «Інтероперабельність, е-послуги та кібербезпека (EU4DigitalUA)», що фінансується із загального бюджету Європейського Союзу', 
        }
    }
};

export default translation_and_params_config;